import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFontStyle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"font-style, fonts, serif"} maskId="square-filled-radius-0-stroke-1-IconFontStyle"><path fillRule="evenodd" clipRule="evenodd" d="M19 20H20.5V21H14.75V20H16.3711L14.418 14H7.95605L6.00293 20H7.5V21H3.5V20H4.9502L10.4854 3H13.4658L19 20ZM8.28125 13H14.0918L11.1865 4.07617L8.28125 13Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFontStyle;
